import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDashboardCountByZoneAndEquipmentStatus } from "./axios/dashboardAxios";
import { getEquipmentStatusColor } from "data/data";

const DELAY_TIME = Number(process.env.REACT_APP_DELAY_TIME) || 60000;

export default function ShipSvgBox() {
    const objectRef = useRef(null);
    const svgDocRef = useRef(null); 
    const navigate = useNavigate();
    const [mapZones, setMapZones] = useState([]);

    // SVG 로드 1회
    useEffect(() => {
        const obj = objectRef.current;
        if (!obj) return;

        const onLoad = () => {
            svgDocRef.current = obj.contentDocument;
            updatePins(svgDocRef.current, mapZones);
        };

        obj.addEventListener("load", onLoad);
        return () => obj.removeEventListener("load", onLoad);
    }, [mapZones]);

    /* ==============================
       2️⃣ API 호출 (마운트 시 1회)
    ============================== */
    useEffect(() => {
        const fetchMapZones = async () => {
            try {
                const mapZones = await getDashboardCountByZoneAndEquipmentStatus();

                // 👉 실제 API 응답 구조에 맞게 수정 필요
                // const zoneDatas = [...mapZones.filter(item => item.managementCompanyName === '인천항만공사')].sort((a, b) =>
                //     b.name.localeCompare(a.name, i18n.language)
                // );
                const zoneDatas = mapZones;
                setMapZones(prev => {
                    const next = zoneDatas.map((info, mapIdx)=>{
                        return {
                            "content":
                            `<div xmlns="http://www.w3.org/1999/xhtml">
                                <div class="map_pin" style="width:250px; padding: 20px; background: unset;">
                                <div id="pinBox-00${mapIdx+1}" style="width: 100%; background: #fff; padding: 10px; border-radius: 10px; border : 1px solid #d3cece;
                                    box-shadow: 0 2px 8px rgba(0,0,0,0.15);color: #000;">
                                    <div style="border-radius:8px; background:${getEquipmentStatusColor(info.countO1N, info.countO2I, info.countO3A, info.countO4C)?.bg};">
                                        <h4 style="margin:0;padding:5px 0;color:#fff;font-size:.9rem;text-align:center;r">${info.managementCompanyName} (${info.name})</h4>
                                    </div>
                                    <div style="padding-top:10px; display : flex; align-items :center;justify-content:center;">
                                        <div class="map_pin0">
                                            <span class="pin1">${info.countO1N}</span>
                                            <span class="pin2">${info.countO2I}</span>
                                            <span class="pin3">${info.countO3A}</span>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>`,
                            zId : info.id
                        }
                    })

                    if (JSON.stringify(prev) === JSON.stringify(next)) {
                        return prev;
                    }
                    console.log(next)
                    return next;
            });

            } catch (err) {
                console.error("Dashboard Zone API Error:", err);
            }
        };

        fetchMapZones(); // 최초 1회

        const intervalId = setInterval(() => {
            fetchMapZones();
        }, DELAY_TIME); // 1분

        return () => clearInterval(intervalId);
    }, []);

    // HTML 변경될 때마다 반영
    useEffect(() => {
        // updatePins();
        if (!svgDocRef.current) return;
        updatePins(svgDocRef.current, mapZones);
    }, [mapZones]);

    const updatePins = (svgDoc, zones) => {
        // if (!svgDoc || !zones?.length) return;
        if (!svgDoc) return;

        // 기존 pin 초기화
        const allPins = svgDoc.querySelectorAll('[id^="pin-obj-00"]');
        allPins.forEach(pin => pin.innerHTML = "");

        if (!zones?.length) return;

        zones.forEach((pinHtml, idx) => {
            const pinId = `pin-obj-00${pinHtml.zId}`;
            const objId = `obj-00${pinHtml.zId}`;

            replacePin(svgDoc, pinId, pinHtml.content);

            const objEl = svgDoc.getElementById(objId);
            if (!objEl) return;

            // 🔥 중복 방지
            objEl.style.cursor = "pointer";
            objEl.onclick = null;
            objEl.onclick = () => {
                navigate(`/dashboard/sub?zId=${pinHtml.zId}`);
            };
        });
    };

    const replacePin = (svgDoc, id, html) => {
        if (!html) return;

        const pin = svgDoc.getElementById(id);
        if (!pin) return;
        // pin.style.display = "block";

        pin.innerHTML = `
            ${html}
        `;
    };

    return (
        <object
        ref={objectRef}
        data="/img/ship.svg"
        type="image/svg+xml"
        // width={1275}
        height={640}
        />
    );
}
